import { captureException } from '@sentry/react-native';

export function logException(error: any) {
  if (process.env.EXPO_PUBLIC_ENV === 'development') {
    console.error(error);
  } else {
    captureException(error);
  }
}
